import { difference } from "./difference";
import { union } from "./union";

export const SpatialUtils = {
    union,
    difference,
};
